import { SERVICE_STATION, COMPANY } from 'store/actions';
import { SERVICE_STATION as GETTERS } from 'store/getters';
import { RootState } from 'types';
import { ComponentOptions } from 'vue';
import {
  selectionListComponent,
  SelectionListMixin,
} from 'components/mixins/selection-list-component';
import { mapState } from 'vuex';
import { ServiceStation } from 'kv_shared/lib/data-types';
import { placeMapInteractions } from 'components/mixins/place-map-setup';
import { createServiceStationRenderOption } from 'utils/map-helpers';

interface Component extends SelectionListMixin<ServiceStation> {
  legendKeysList: any[];
}

export default {
  created() {
    this.$store.dispatch(COMPANY.LOAD_COMPLETE_LIST);
  },

  data() {
    return {
      legendKeysList: [
        {
          label: 'DB Energie',
          class: '',
          color: '#ee0000',
        },
      ],
    };
  },

  mixins: [
    selectionListComponent(SERVICE_STATION, GETTERS),
    placeMapInteractions(),
  ],

  computed: {
    ...mapState<RootState>({
      item: state => state.serviceStations.selectedItem,
      items: state => state.serviceStations.items, // needed for map rendering
    }),

    listWithMarkers(this: Component) {
      return this.list.map(item => {
        return {
          ...item,
          marker: this.legendKeysList[0],
        };
      });
    },

    company(this: Component) {
      if (this.item && this.item.company.uid) {
        return this.companies[this.item.company.uid];
      }
    },

    keysActive() {
      return this.currentSelection.startCountry;
    },
  },

  methods: {
    getPlaceMapRenderOptions(s: ServiceStation) {
      return createServiceStationRenderOption(
        s,
        this.locations,
        this.item && this.item.uid === s.uid,
      );
    },

    convertServiceStationInfosToList(infos) {
      const converted: any[] = [];
      const list: any[] = [];

      Object.entries(infos).forEach(([key, value]) => {
        let label = key;

        switch (key) {
          case 'track':
            label = this.$t('Gleis');
            break;
          case 'serviceNews':
            label = this.$t('Servicemeldungen');
            break;
          case 'furtherInfos':
            label = this.$t('Weitere Informationen');
            break;
          case 'furtherContacts':
            label = this.$t('Weitere Ansprechpartner');
            break;
        }

        list.push({
          label,
          value,
        });
      });

      converted.push({
        list,
      });

      return converted;
    },
  },
} as ComponentOptions<Component>;
